// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxCircleFilledSvg from "@ant-design/icons-svg/es/asn/DropboxCircleFilled";
import AntdIcon from '../components/AntdIcon';

var DropboxCircleFilled = function DropboxCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DropboxCircleFilledSvg
  }));
};

DropboxCircleFilled.displayName = 'DropboxCircleFilled';
export default React.forwardRef(DropboxCircleFilled);